/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    baseUrl = "";
    securityData = null;
    securityWorker;
    abortControllers = new Map();
    customFetch = (...fetchParams) => fetch(...fetchParams);
    baseApiParams = {
        credentials: "same-origin",
        headers: {},
        redirect: "follow",
        referrerPolicy: "no-referrer",
    };
    constructor(apiConfig = {}) {
        Object.assign(this, apiConfig);
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join("&");
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join("&");
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }
    contentFormatters = {
        [ContentType.Json]: (input) => input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
        [ContentType.Text]: (input) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
        [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === "object" && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData()),
        [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
    };
    mergeRequestParams(params1, params2) {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    createAbortSignal = (cancelToken) => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }
        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };
    abortRequest = (cancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);
        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };
    request = async ({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;
        return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone();
            r.data = null;
            r.error = null;
            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                    .then((data) => {
                    if (r.ok) {
                        r.data = data;
                    }
                    else {
                        r.error = data;
                    }
                    return r;
                })
                    .catch((e) => {
                    r.error = e;
                    return r;
                });
            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }
            if (!response.ok)
                throw data;
            return data;
        });
    };
}
/**
 * @title CoreService
 * @version 1.0.0
 *
 * Houses supporting services
 */
export class Api extends HttpClient {
    readiness = {
        /**
         * No description
         *
         * @tags z_Readiness
         * @name ReadinessList
         * @request GET:/readiness
         */
        readinessList: (params = {}) => this.request({
            path: `/readiness`,
            method: "GET",
            ...params,
        }),
    };
    core = {
        /**
         * @description Get a presigned URL to upload a file to S3
         *
         * @tags Attachments
         * @name AttachmentsCreate
         * @request POST:/core/attachments
         * @secure
         */
        attachmentsCreate: (query, params = {}) => this.request({
            path: `/core/attachments`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a list of public attachment objects on S3
         *
         * @tags Attachments
         * @name AttachmentsList
         * @request GET:/core/attachments
         * @secure
         */
        attachmentsList: (query, params = {}) => this.request({
            path: `/core/attachments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Rename a public attachment object on S3
         *
         * @tags Attachments
         * @name AttachmentsUpdate
         * @request PUT:/core/attachments
         * @secure
         */
        attachmentsUpdate: (data, params = {}) => this.request({
            path: `/core/attachments`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a public attachment object on S3
         *
         * @tags Attachments
         * @name AttachmentsDelete
         * @request DELETE:/core/attachments
         * @secure
         */
        attachmentsDelete: (query, params = {}) => this.request({
            path: `/core/attachments`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsList
         * @request GET:/core/background-jobs
         * @secure
         */
        backgroundJobsList: (query, params = {}) => this.request({
            path: `/core/background-jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsCreate
         * @request POST:/core/background-jobs
         * @secure
         */
        backgroundJobsCreate: (data, params = {}) => this.request({
            path: `/core/background-jobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsActiveJobsList
         * @request GET:/core/background-jobs/active-jobs
         * @secure
         */
        backgroundJobsActiveJobsList: (query, params = {}) => this.request({
            path: `/core/background-jobs/active-jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsResultsCreate
         * @request POST:/core/background-jobs/results
         * @secure
         */
        backgroundJobsResultsCreate: (data, params = {}) => this.request({
            path: `/core/background-jobs/results`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsCancelJobUpdate
         * @request PUT:/core/background-jobs/cancel-job
         * @secure
         */
        backgroundJobsCancelJobUpdate: (data, params = {}) => this.request({
            path: `/core/background-jobs/cancel-job`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsActiveJobTypesList
         * @request GET:/core/background-jobs/active-job-types
         * @secure
         */
        backgroundJobsActiveJobTypesList: (params = {}) => this.request({
            path: `/core/background-jobs/active-job-types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Retrieves country data (states, postal code format, iso2, etc.) for all countries.
         *
         * @tags Country
         * @name CountriesList
         * @summary Retrieve country data
         * @request GET:/core/countries
         */
        countriesList: (params = {}) => this.request({
            path: `/core/countries`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new CRM request
         *
         * @tags CRM, CRM Requests
         * @name PostCore
         * @request POST:/core/crm
         * @secure
         */
        postCore: (data, params = {}) => this.request({
            path: `/core/crm`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Custom Fields
         * @name CustomFieldsList
         * @request GET:/core/custom-fields
         * @secure
         */
        customFieldsList: (query, params = {}) => this.request({
            path: `/core/custom-fields`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Custom Fields
         * @name CustomFieldsCreate
         * @request POST:/core/custom-fields
         * @secure
         */
        customFieldsCreate: (data, params = {}) => this.request({
            path: `/core/custom-fields`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsImportDefinitionCreate
         * @request POST:/core/data-imports/import-definition
         * @secure
         */
        dataImportsImportDefinitionCreate: (data, params = {}) => this.request({
            path: `/core/data-imports/import-definition`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsImportDefinitionDelete
         * @request DELETE:/core/data-imports/import-definition
         * @secure
         */
        dataImportsImportDefinitionDelete: (data, params = {}) => this.request({
            path: `/core/data-imports/import-definition`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsImportDefinitionList
         * @request GET:/core/data-imports/import-definition
         * @secure
         */
        dataImportsImportDefinitionList: (params = {}) => this.request({
            path: `/core/data-imports/import-definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsDefAvailabilityUpdate
         * @request PUT:/core/data-imports/def-availability
         * @secure
         */
        dataImportsDefAvailabilityUpdate: (data, params = {}) => this.request({
            path: `/core/data-imports/def-availability`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsSpecialInstructionsUpdate
         * @request PUT:/core/data-imports/special-instructions
         * @secure
         */
        dataImportsSpecialInstructionsUpdate: (data, params = {}) => this.request({
            path: `/core/data-imports/special-instructions`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all CRM departments
         *
         * @tags CRM Departments
         * @name DepartmentsList
         * @request GET:/core/departments
         * @secure
         */
        departmentsList: (params = {}) => this.request({
            path: `/core/departments`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new department
         *
         * @tags CRM Departments
         * @name DepartmentsCreate
         * @request POST:/core/departments
         */
        departmentsCreate: (data, params = {}) => this.request({
            path: `/core/departments`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all display groups for the current site
         *
         * @tags Display Groups
         * @name DisplayGroupsList
         * @request GET:/core/display-groups
         * @secure
         */
        displayGroupsList: (params = {}) => this.request({
            path: `/core/display-groups`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get core documents
         *
         * @tags Documents
         * @name DocumentsList
         * @request GET:/core/documents
         * @secure
         */
        documentsList: (query, params = {}) => this.request({
            path: `/core/documents`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Event Logger
         * @name EventLoggerCreate
         * @request POST:/core/event-logger
         * @secure
         */
        eventLoggerCreate: (data, params = {}) => this.request({
            path: `/core/event-logger`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Enqueue Site Export Job
         *
         * @tags Export Site
         * @name ExportSiteCreate
         * @request POST:/core/export-site
         * @secure
         */
        exportSiteCreate: (data, params = {}) => this.request({
            path: `/core/export-site`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get feature flags for a site, optionally filtered by feature flag names
         *
         * @tags Feature Flags
         * @name FeatureFlagsList
         * @request GET:/core/feature-flags
         */
        featureFlagsList: (query, params = {}) => this.request({
            path: `/core/feature-flags`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a presigned URL to upload a file to S3
         *
         * @tags File Upload
         * @name FileCreate
         * @request POST:/core/file
         * @secure
         */
        fileCreate: (query, params = {}) => this.request({
            path: `/core/file`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyIntegrationCreate
         * @request POST:/core/gis-copy/integration
         * @secure
         */
        gisCopyIntegrationCreate: (data, params = {}) => this.request({
            path: `/core/gis-copy/integration`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyIntegrationUpdate
         * @request PUT:/core/gis-copy/integration/{id}
         * @secure
         */
        gisCopyIntegrationUpdate: (id, data, params = {}) => this.request({
            path: `/core/gis-copy/integration/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyIntegrationDetail
         * @request GET:/core/gis-copy/integration/{id}
         * @secure
         */
        gisCopyIntegrationDetail: (id, params = {}) => this.request({
            path: `/core/gis-copy/integration/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyEnableIntegrationUpdate
         * @request PUT:/core/gis-copy/enable-integration
         * @secure
         */
        gisCopyEnableIntegrationUpdate: (data, params = {}) => this.request({
            path: `/core/gis-copy/enable-integration`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyDisableIntegrationUpdate
         * @request PUT:/core/gis-copy/disable-integration
         * @secure
         */
        gisCopyDisableIntegrationUpdate: (data, params = {}) => this.request({
            path: `/core/gis-copy/disable-integration`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyDeleteIntegrationDelete
         * @request DELETE:/core/gis-copy/delete-integration/{id}
         * @secure
         */
        gisCopyDeleteIntegrationDelete: (id, params = {}) => this.request({
            path: `/core/gis-copy/delete-integration/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyRetrieveLayerCreate
         * @request POST:/core/gis-copy/retrieve-layer
         * @secure
         */
        gisCopyRetrieveLayerCreate: (data, params = {}) => this.request({
            path: `/core/gis-copy/retrieve-layer`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyTestIntegrationCreate
         * @request POST:/core/gis-copy/test-integration
         * @secure
         */
        gisCopyTestIntegrationCreate: (data, params = {}) => this.request({
            path: `/core/gis-copy/test-integration`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopyIntegrationsList
         * @request GET:/core/gis-copy/integrations
         * @secure
         */
        gisCopyIntegrationsList: (params = {}) => this.request({
            path: `/core/gis-copy/integrations`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Copy
         * @name GisCopySyncCreate
         * @request POST:/core/gis-copy/sync
         * @secure
         */
        gisCopySyncCreate: (data, params = {}) => this.request({
            path: `/core/gis-copy/sync`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Spatial Reference
         * @name GisSpatialReferenceCreate
         * @request POST:/core/gis-spatial-reference
         * @secure
         */
        gisSpatialReferenceCreate: (data, params = {}) => this.request({
            path: `/core/gis-spatial-reference`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Spatial Reference
         * @name GisSpatialReferenceList
         * @request GET:/core/gis-spatial-reference
         * @secure
         */
        gisSpatialReferenceList: (params = {}) => this.request({
            path: `/core/gis-spatial-reference`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags GIS Spatial Reference
         * @name GisSpatialReferenceDelete
         * @request DELETE:/core/gis-spatial-reference
         * @secure
         */
        gisSpatialReferenceDelete: (params = {}) => this.request({
            path: `/core/gis-spatial-reference`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Provides a health check for the core service by returning a list of dependencies and their statuses
         *
         * @tags Health Check
         * @name HealthCheckList
         * @request GET:/core/health-check
         * @secure
         */
        healthCheckList: (query, params = {}) => this.request({
            path: `/core/health-check`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all inspections for a given city
         *
         * @tags Inspections
         * @name InspectionsList
         * @request GET:/core/inspections
         * @secure
         */
        inspectionsList: (query, params = {}) => this.request({
            path: `/core/inspections`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new inspection-type for a given city
         *
         * @tags Inspections
         * @name InspectionsCreate
         * @request POST:/core/inspections
         * @secure
         */
        inspectionsCreate: (data, params = {}) => this.request({
            path: `/core/inspections`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get ALL locations. [NOTE] This endpoint isn't paginated, but really should be
         *
         * @tags Locations
         * @name LocationsList
         * @request GET:/core/locations
         * @secure
         */
        locationsList: (params = {}) => this.request({
            path: `/core/locations`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Locations
         * @name LocationsCreate
         * @request POST:/core/locations
         * @secure
         */
        locationsCreate: (data, params = {}) => this.request({
            path: `/core/locations`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all object managers
         *
         * @tags Object Manager
         * @name ObjectManagerList
         * @request GET:/core/object-manager
         * @secure
         */
        objectManagerList: (params = {}) => this.request({
            path: `/core/object-manager`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Release Notes
         * @name ReleaseNotesList
         * @request GET:/core/release-notes/
         * @secure
         */
        releaseNotesList: (params = {}) => this.request({
            path: `/core/release-notes/`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Get all reports for a site
         *
         * @tags Legacy Reports
         * @name ReportsList
         * @request GET:/core/reports
         * @secure
         */
        reportsList: (query, params = {}) => this.request({
            path: `/core/reports`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags File Upload
         * @name UploadToolCredentialsList
         * @request GET:/core/upload-tool/credentials
         * @secure
         */
        uploadToolCredentialsList: (params = {}) => this.request({
            path: `/core/upload-tool/credentials`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags File Upload
         * @name UploadToolFolderCreate
         * @request POST:/core/upload-tool/folder
         * @secure
         */
        uploadToolFolderCreate: (data, params = {}) => this.request({
            path: `/core/upload-tool/folder`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags File Upload
         * @name UploadToolFolderList
         * @request GET:/core/upload-tool/folder
         * @secure
         */
        uploadToolFolderList: (params = {}) => this.request({
            path: `/core/upload-tool/folder`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags File Upload
         * @name UploadToolFolderDelete
         * @request DELETE:/core/upload-tool/folder
         * @secure
         */
        uploadToolFolderDelete: (data, params = {}) => this.request({
            path: `/core/upload-tool/folder`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags File Upload
         * @name UploadToolUrlsCreate
         * @request POST:/core/upload-tool/urls
         * @secure
         */
        uploadToolUrlsCreate: (data, params = {}) => this.request({
            path: `/core/upload-tool/urls`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Custom Fields
         * @name CustomFieldsCreate2
         * @request POST:/core/{objectType}/custom-fields
         * @originalName customFieldsCreate
         * @duplicate
         * @secure
         */
        customFieldsCreate2: (objectType, data, params = {}) => this.request({
            path: `/core/${objectType}/custom-fields`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get general agency settings, such as timezone information. Endpoint is left unsecured intentionally.
         *
         * @tags Agency
         * @name AgencySettingsList
         * @summary Get general agency settings
         * @request GET:/core/agency/settings
         */
        agencySettingsList: (params = {}) => this.request({
            path: `/core/agency/settings`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Retrieve attachment object by key
         *
         * @tags Attachments
         * @name AttachmentsAttachmentAttachmentList
         * @request GET:/core/attachments/attachment/attachment
         * @secure
         */
        attachmentsAttachmentAttachmentList: (query, params = {}) => this.request({
            path: `/core/attachments/attachment/attachment`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Verify a JWT token
         *
         * @tags Auth
         * @name AuthValidateCreate
         * @request POST:/core/auth/validate
         */
        authValidateCreate: (params = {}) => this.request({
            path: `/core/auth/validate`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsDetail
         * @request GET:/core/background-jobs/{id}
         * @secure
         */
        backgroundJobsDetail: (id, params = {}) => this.request({
            path: `/core/background-jobs/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsUpdate
         * @request PUT:/core/background-jobs/{id}
         * @secure
         */
        backgroundJobsUpdate: (id, data, params = {}) => this.request({
            path: `/core/background-jobs/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Background Jobs
         * @name BackgroundJobsMeList
         * @request GET:/core/background-jobs/me
         * @secure
         */
        backgroundJobsMeList: (query, params = {}) => this.request({
            path: `/core/background-jobs/me`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CE Cases
         * @name CeCasesList
         * @request GET:/core/ce/cases
         * @secure
         */
        ceCasesList: (query, params = {}) => this.request({
            path: `/core/ce/cases`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a list of the agency's CE custom fields.
         *
         * @tags CE
         * @name CeCustomFieldsList
         * @request GET:/core/ce/custom-fields
         * @secure
         */
        ceCustomFieldsList: (params = {}) => this.request({
            path: `/core/ce/custom-fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get an agency's CE general settings.
         *
         * @tags CE
         * @name CeGeneralSettingsList
         * @request GET:/core/ce/general-settings
         * @secure
         */
        ceGeneralSettingsList: (params = {}) => this.request({
            path: `/core/ce/general-settings`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an agency's CE general settings.
         *
         * @tags CE
         * @name CeGeneralSettingsPartialUpdate
         * @request PATCH:/core/ce/general-settings
         * @secure
         */
        ceGeneralSettingsPartialUpdate: (data, params = {}) => this.request({
            path: `/core/ce/general-settings`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportCaseStandardImportCreate
         * @request POST:/core/ce/import/case-standard-import
         * @secure
         */
        ceImportCaseStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/case-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportCaseCustomImportCreate
         * @request POST:/core/ce/import/case-custom-import
         * @secure
         */
        ceImportCaseCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/case-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportActionStandardImportCreate
         * @request POST:/core/ce/import/action-standard-import
         * @secure
         */
        ceImportActionStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/action-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportActionCustomImportCreate
         * @request POST:/core/ce/import/action-custom-import
         * @secure
         */
        ceImportActionCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/action-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportAttachmentStandardImportCreate
         * @request POST:/core/ce/import/attachment-standard-import
         * @secure
         */
        ceImportAttachmentStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/attachment-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportAttachmentCustomImportCreate
         * @request POST:/core/ce/import/attachment-custom-import
         * @secure
         */
        ceImportAttachmentCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/attachment-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportViolationStandardImportCreate
         * @request POST:/core/ce/import/violation-standard-import
         * @secure
         */
        ceImportViolationStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/violation-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportViolationCustomImportCreate
         * @request POST:/core/ce/import/violation-custom-import
         * @secure
         */
        ceImportViolationCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/violation-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportAddressStandardImportCreate
         * @request POST:/core/ce/import/address-standard-import
         * @secure
         */
        ceImportAddressStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/address-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CeImportAddressCustomImportCreate
         * @request POST:/core/ce/import/address-custom-import
         * @secure
         */
        ceImportAddressCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/ce/import/address-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Search for CE letters based on various criteria.
         *
         * @tags CE Letters
         * @name CeLettersList
         * @request GET:/core/ce/letters
         * @secure
         */
        ceLettersList: (query, params = {}) => this.request({
            path: `/core/ce/letters`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate CE letters in the background job.
         *
         * @tags CE Letters
         * @name CeLettersCreate
         * @request POST:/core/ce/letters
         * @secure
         */
        ceLettersCreate: (data, params = {}) => this.request({
            path: `/core/ce/letters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Code Properties
         * @name CePropertiesList
         * @request GET:/core/ce/properties
         * @secure
         */
        cePropertiesList: (query, params = {}) => this.request({
            path: `/core/ce/properties`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Code Statuses
         * @name CeStatusesList
         * @request GET:/core/ce/statuses
         * @secure
         */
        ceStatusesList: (params = {}) => this.request({
            path: `/core/ce/statuses`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CE Topics
         * @name CeTopicsList
         * @request GET:/core/ce/topics
         * @secure
         */
        ceTopicsList: (params = {}) => this.request({
            path: `/core/ce/topics`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Violation Types
         * @name CeViolationTypesList
         * @request GET:/core/ce/violation-types
         * @secure
         */
        ceViolationTypesList: (params = {}) => this.request({
            path: `/core/ce/violation-types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Send a templated email to one or many recipients
         *
         * @tags Communications
         * @name CommunicationsEmailCreate
         * @request POST:/core/communications/email
         * @secure
         */
        communicationsEmailCreate: (data, params = {}) => this.request({
            path: `/core/communications/email`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ContactsImportStandardImportCreate
         * @request POST:/core/contacts/import/standard-import
         * @secure
         */
        contactsImportStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/contacts/import/standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name ContactsImportCustomImportCreate
         * @request POST:/core/contacts/import/custom-import
         * @secure
         */
        contactsImportCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/contacts/import/custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportRequestStandardImportCreate
         * @request POST:/core/crm/import/request-standard-import
         * @secure
         */
        crmImportRequestStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/request-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportRequestCustomImportCreate
         * @request POST:/core/crm/import/request-custom-import
         * @secure
         */
        crmImportRequestCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/request-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportAttachmentStandardImportCreate
         * @request POST:/core/crm/import/attachment-standard-import
         * @secure
         */
        crmImportAttachmentStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/attachment-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportAttachmentCustomImportCreate
         * @request POST:/core/crm/import/attachment-custom-import
         * @secure
         */
        crmImportAttachmentCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/attachment-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportCommentStandardImportCreate
         * @request POST:/core/crm/import/comment-standard-import
         * @secure
         */
        crmImportCommentStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/comment-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name CrmImportCommentCustomImportCreate
         * @request POST:/core/crm/import/comment-custom-import
         * @secure
         */
        crmImportCommentCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/crm/import/comment-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a list of the current user's requests
         *
         * @tags CRM, CRM Requests
         * @name CrmPublicList
         * @request GET:/core/crm/public
         * @secure
         */
        crmPublicList: (query, params = {}) => this.request({
            path: `/core/crm/public`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Search CRM cases
         *
         * @tags CRM
         * @name CrmSearchCreate
         * @request POST:/core/crm/search
         * @secure
         */
        crmSearchCreate: (data, params = {}) => this.request({
            path: `/core/crm/search`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get an agency's CRM general settings.
         *
         * @tags CRM
         * @name CrmSettingsList
         * @request GET:/core/crm/settings
         * @secure
         */
        crmSettingsList: (params = {}) => this.request({
            path: `/core/crm/settings`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an agency's CRM general settings.
         *
         * @tags CRM
         * @name CrmSettingsPartialUpdate
         * @request PATCH:/core/crm/settings
         * @secure
         */
        crmSettingsPartialUpdate: (data, params = {}) => this.request({
            path: `/core/crm/settings`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Crm Statuses
         * @name CrmStatusesList
         * @request GET:/core/crm/statuses
         * @secure
         */
        crmStatusesList: (params = {}) => this.request({
            path: `/core/crm/statuses`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all CRM topics for the current site
         *
         * @tags Crm Topics
         * @name CrmTopicsList
         * @request GET:/core/crm/topics
         * @secure
         */
        crmTopicsList: (query, params = {}) => this.request({
            path: `/core/crm/topics`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new topic
         *
         * @tags Topics
         * @name CrmTopicsCreate
         * @request POST:/core/crm/topics
         */
        crmTopicsCreate: (data, params = {}) => this.request({
            path: `/core/crm/topics`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update some properties of a custom field, update some properties of nested picklist, upsert nested picklist items
         *
         * @tags Custom Fields
         * @name CustomFieldsPartialUpdate
         * @request PATCH:/core/custom-fields/{id}
         * @secure
         */
        customFieldsPartialUpdate: (id, data, params = {}) => this.request({
            path: `/core/custom-fields/${id}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name DataImportsImportTypesList
         * @request GET:/core/data-imports/import-types
         * @secure
         */
        dataImportsImportTypesList: (params = {}) => this.request({
            path: `/core/data-imports/import-types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a department by ID
         *
         * @tags CRM Departments
         * @name DepartmentsDetail
         * @request GET:/core/departments/{id}
         */
        departmentsDetail: (id, params = {}) => this.request({
            path: `/core/departments/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Update department
         *
         * @tags CRM Departments
         * @name DepartmentsUpdate
         * @request PUT:/core/departments/{id}
         */
        departmentsUpdate: (id, data, params = {}) => this.request({
            path: `/core/departments/${id}`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a department
         *
         * @tags CRM Departments
         * @name DepartmentsDelete
         * @request DELETE:/core/departments/{id}
         */
        departmentsDelete: (id, params = {}) => this.request({
            path: `/core/departments/${id}`,
            method: "DELETE",
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate core documents. Ids is a comma separated list (e.g. ?ids=1,2,3)
         *
         * @tags Documents
         * @name DocumentsDeactivatedUpdate
         * @request PUT:/core/documents/deactivated
         * @secure
         */
        documentsDeactivatedUpdate: (query, params = {}) => this.request({
            path: `/core/documents/deactivated`,
            method: "PUT",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Restore core documents. Ids is a comma separated list (e.g. ?ids=1,2,3)
         *
         * @tags Documents
         * @name DocumentsDeactivatedDelete
         * @request DELETE:/core/documents/deactivated
         * @secure
         */
        documentsDeactivatedDelete: (query, params = {}) => this.request({
            path: `/core/documents/deactivated`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Documents
         * @name DocumentsTemplatesCreate
         * @request POST:/core/documents/templates
         * @secure
         */
        documentsTemplatesCreate: (data, params = {}) => this.request({
            path: `/core/documents/templates`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get All Document Templates, filtered by deactivation status and record type. Ids and permitsTypeIds are comma separated lists (e.g. ?ids=1,2,3).
         *
         * @tags Documents
         * @name DocumentsTemplatesList
         * @request GET:/core/documents/templates
         * @secure
         */
        documentsTemplatesList: (query, params = {}) => this.request({
            path: `/core/documents/templates`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Event Logger
         * @name EventLoggerSearchCreate
         * @request POST:/core/event-logger/search
         * @secure
         */
        eventLoggerSearchCreate: (data, params = {}) => this.request({
            path: `/core/event-logger/search`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Check if a feature flag is active for a site
         *
         * @tags Feature Flags
         * @name FeatureFlagsDetail
         * @request GET:/core/feature-flags/{name}
         */
        featureFlagsDetail: (name, params = {}) => this.request({
            path: `/core/feature-flags/${name}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Gets the file URL and metadata for a core file object
         *
         * @tags File Upload
         * @name FileDetail
         * @request GET:/core/file/{id}
         * @secure
         */
        fileDetail: (id, params = {}) => this.request({
            path: `/core/file/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a multipart upload to S3
         *
         * @tags File Upload
         * @name FileMultipartCreate
         * @request POST:/core/file/multipart
         * @secure
         */
        fileMultipartCreate: (query, params = {}) => this.request({
            path: `/core/file/multipart`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the current health status of the core service workers
         *
         * @tags Health Check
         * @name HealthCheckWorkerList
         * @request GET:/core/health-check/worker
         */
        healthCheckWorkerList: (query, params = {}) => this.request({
            path: `/core/health-check/worker`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description List all inspection-types for a given city
         *
         * @tags Inspections
         * @name InspectionsDetail
         * @request GET:/core/inspections/{id}
         * @secure
         */
        inspectionsDetail: (id, query, params = {}) => this.request({
            path: `/core/inspections/${id}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Hard delete an inspection by id
         *
         * @tags Inspections
         * @name InspectionsDelete
         * @request DELETE:/core/inspections/{id}
         * @secure
         */
        inspectionsDelete: (id, params = {}) => this.request({
            path: `/core/inspections/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the number of requested inspection for a city
         *
         * @tags Inspections
         * @name InspectionsRequestedList
         * @request GET:/core/inspections/requested
         * @secure
         */
        inspectionsRequestedList: (params = {}) => this.request({
            path: `/core/inspections/requested`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all inspection-types for a given city
         *
         * @tags Inspections
         * @name InspectionsPublicList
         * @request GET:/core/inspections/public
         * @secure
         */
        inspectionsPublicList: (query, params = {}) => this.request({
            path: `/core/inspections/public`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all inspection-types for a given city
         *
         * @tags Inspections
         * @name InspectionsTypesList
         * @request GET:/core/inspections/types
         * @secure
         */
        inspectionsTypesList: (query, params = {}) => this.request({
            path: `/core/inspections/types`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new inspection-type for a given city
         *
         * @tags Inspections
         * @name InspectionsTypesCreate
         * @request POST:/core/inspections/types
         * @secure
         */
        inspectionsTypesCreate: (data, params = {}) => this.request({
            path: `/core/inspections/types`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Return the Filters for a given inspection list view
         *
         * @tags Inspections
         * @name InspectionsViewsList
         * @request GET:/core/inspections/views
         * @secure
         */
        inspectionsViewsList: (query, params = {}) => this.request({
            path: `/core/inspections/views`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Send an email to the sales team with information for customers interested in Integrations they do not have
         *
         * @tags Integrations
         * @name IntegrationsInformationCreate
         * @request POST:/core/integrations/information
         * @secure
         */
        integrationsInformationCreate: (data, params = {}) => this.request({
            path: `/core/integrations/information`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all data sync integrations for the city and all default configurations.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncList
         * @request GET:/core/integrations/data-sync
         * @secure
         */
        integrationsDataSyncList: (params = {}) => this.request({
            path: `/core/integrations/data-sync`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncCreate
         * @request POST:/core/integrations/data-sync
         * @secure
         */
        integrationsDataSyncCreate: (data, params = {}) => this.request({
            path: `/core/integrations/data-sync`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get function returns the short City ID for the site in the headers
         *
         * @tags Link Shortener
         * @name LinkShortenerDetail
         * @request GET:/core/link-shortener/{site}
         */
        linkShortenerDetail: (site, params = {}) => this.request({
            path: `/core/link-shortener/${site}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get a location by id
         *
         * @tags Locations
         * @name LocationsDetail
         * @request GET:/core/locations/{id}
         * @secure
         */
        locationsDetail: (id, params = {}) => this.request({
            path: `/core/locations/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a location by id
         *
         * @tags Locations
         * @name LocationsUpdate
         * @request PUT:/core/locations/{id}
         * @secure
         */
        locationsUpdate: (id, data, params = {}) => this.request({
            path: `/core/locations/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name LocationsImportStandardImportCreate
         * @request POST:/core/locations/import/standard-import
         * @secure
         */
        locationsImportStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/locations/import/standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name LocationsImportCustomImportCreate
         * @request POST:/core/locations/import/custom-import
         * @secure
         */
        locationsImportCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/locations/import/custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Users
         * @name LocationsImportGenerateTemplateCreate
         * @request POST:/core/locations/import/generate-template
         * @secure
         */
        locationsImportGenerateTemplateCreate: (data, params = {}) => this.request({
            path: `/core/locations/import/generate-template`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * No description
         *
         * @tags Locations
         * @name LocationsSearchCreate
         * @request POST:/core/locations/search
         * @secure
         */
        locationsSearchCreate: (data, params = {}) => this.request({
            path: `/core/locations/search`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all AdHoc features by the user
         *
         * @tags Mapping
         * @name MappingFeaturesList
         * @request GET:/core/mapping/features
         * @secure
         */
        mappingFeaturesList: (params = {}) => this.request({
            path: `/core/mapping/features`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create new AdHoc feature(s) for the user
         *
         * @tags Mapping
         * @name MappingFeaturesCreate
         * @request POST:/core/mapping/features
         * @secure
         */
        mappingFeaturesCreate: (data, params = {}) => this.request({
            path: `/core/mapping/features`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk update Adhoc features
         *
         * @tags Mapping
         * @name MappingFeaturesUpdate
         * @request PUT:/core/mapping/features
         * @secure
         */
        mappingFeaturesUpdate: (data, params = {}) => this.request({
            path: `/core/mapping/features`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk delete Adhoc features
         *
         * @tags Mapping
         * @name MappingFeaturesDelete
         * @request DELETE:/core/mapping/features
         * @secure
         */
        mappingFeaturesDelete: (data, params = {}) => this.request({
            path: `/core/mapping/features`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Search for geocode results
         *
         * @tags Mapping
         * @name MappingGeocodeResultsList
         * @request GET:/core/mapping/geocode-results
         * @secure
         */
        mappingGeocodeResultsList: (query, params = {}) => this.request({
            path: `/core/mapping/geocode-results`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Add a geocode result
         *
         * @tags Mapping
         * @name MappingGeocodeResultsCreate
         * @request POST:/core/mapping/geocode-results
         * @secure
         */
        mappingGeocodeResultsCreate: (data, params = {}) => this.request({
            path: `/core/mapping/geocode-results`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all map layers
         *
         * @tags Mapping
         * @name MappingLayersList
         * @request GET:/core/mapping/layers
         * @secure
         */
        mappingLayersList: (params = {}) => this.request({
            path: `/core/mapping/layers`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new map layer
         *
         * @tags Mapping
         * @name MappingLayersCreate
         * @request POST:/core/mapping/layers
         * @secure
         */
        mappingLayersCreate: (data, params = {}) => this.request({
            path: `/core/mapping/layers`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a static map if it does not already exist
         *
         * @tags Mapping, Static Maps
         * @name MappingStaticMapCreate
         * @request POST:/core/mapping/static-map
         * @secure
         */
        mappingStaticMapCreate: (data, params = {}) => this.request({
            path: `/core/mapping/static-map`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a static map
         *
         * @tags Mapping, Static Maps
         * @name MappingStaticMapList
         * @request GET:/core/mapping/static-map
         * @secure
         */
        mappingStaticMapList: (query, params = {}) => this.request({
            path: `/core/mapping/static-map`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get branding assets for a site
         *
         * @tags Mobile Branding
         * @name MobileBrandingList
         * @request GET:/core/mobile/branding
         * @secure
         */
        mobileBrandingList: (params = {}) => this.request({
            path: `/core/mobile/branding`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Set branding assets for a site
         *
         * @tags Mobile Branding
         * @name MobileBrandingUpdate
         * @request PUT:/core/mobile/branding
         * @secure
         */
        mobileBrandingUpdate: (data, params = {}) => this.request({
            path: `/core/mobile/branding`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get publishing assets for a site
         *
         * @tags Mobile Publish
         * @name MobilePublishList
         * @request GET:/core/mobile/publish
         */
        mobilePublishList: (params = {}) => this.request({
            path: `/core/mobile/publish`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Set publishing assets for a site
         *
         * @tags Mobile Publish
         * @name MobilePublishUpdate
         * @request PUT:/core/mobile/publish
         * @secure
         */
        mobilePublishUpdate: (data, params = {}) => this.request({
            path: `/core/mobile/publish`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get branded app configuration for a site
         *
         * @tags Mobile
         * @name MobileSiteInfoList
         * @request GET:/core/mobile/site-info
         */
        mobileSiteInfoList: (params = {}) => this.request({
            path: `/core/mobile/site-info`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Send an invite SMS to a user (rate limited to 1 call per minute)
         *
         * @tags Notify
         * @name NotifyInviteCreate
         * @request POST:/core/notify/invite
         */
        notifyInviteCreate: (data, params = {}) => this.request({
            path: `/core/notify/invite`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create notification content
         *
         * @tags Notify
         * @name NotifyNotificationContentCreate
         * @request POST:/core/notify/notification-content
         * @secure
         */
        notifyNotificationContentCreate: (data, params = {}) => this.request({
            path: `/core/notify/notification-content`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Send a batch of push notifications
         *
         * @tags Notify
         * @name NotifyPushNotificationCreate
         * @request POST:/core/notify/push-notification
         * @secure
         */
        notifyPushNotificationCreate: (data, params = {}) => this.request({
            path: `/core/notify/push-notification`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Notify
         * @name NotifySettingsList
         * @request GET:/core/notify/settings
         * @secure
         */
        notifySettingsList: (params = {}) => this.request({
            path: `/core/notify/settings`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the SMS Settings for a site
         *
         * @tags Notify
         * @name NotifySettingsUpdate
         * @request PUT:/core/notify/settings
         * @secure
         */
        notifySettingsUpdate: (data, params = {}) => this.request({
            path: `/core/notify/settings`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Upsert a subscriber contact method. `personId` will automatically be set to the authenticated user's ID. If the user is an internal admin or service-to-service, the personId can be overridden by providing it in the request body.
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodUpdate
         * @request PUT:/core/notify/subscriber-contact-method
         * @secure
         */
        notifySubscriberContactMethodUpdate: (data, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all subscription groups
         *
         * @tags Notify
         * @name NotifySubscriptionGroupList
         * @request GET:/core/notify/subscription-group
         * @secure
         */
        notifySubscriptionGroupList: (query, params = {}) => this.request({
            path: `/core/notify/subscription-group`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a subscription group
         *
         * @tags Notify
         * @name NotifySubscriptionGroupCreate
         * @request POST:/core/notify/subscription-group
         * @secure
         */
        notifySubscriptionGroupCreate: (data, params = {}) => this.request({
            path: `/core/notify/subscription-group`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Upsert Notify subscription preferences
         *
         * @tags Notify
         * @name NotifySubscriptionPreferenceUpdate
         * @request PUT:/core/notify/subscription-preference
         * @secure
         */
        notifySubscriptionPreferenceUpdate: (data, params = {}) => this.request({
            path: `/core/notify/subscription-preference`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get field definitions for a given object type
         *
         * @tags Object Manager
         * @name ObjectManagerDetail
         * @request GET:/core/object-manager/{objectType}
         * @secure
         */
        objectManagerDetail: (objectType, query, params = {}) => this.request({
            path: `/core/object-manager/${objectType}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name PermitsImportStandardImportCreate
         * @request POST:/core/permits/import/standard-import
         * @secure
         */
        permitsImportStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/permits/import/standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name PermitsImportCustomImportCreate
         * @request POST:/core/permits/import/custom-import
         * @secure
         */
        permitsImportCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/permits/import/custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name PermitsImportAttachmentsStandardImportCreate
         * @request POST:/core/permits/import/attachments-standard-import
         * @secure
         */
        permitsImportAttachmentsStandardImportCreate: (data, params = {}) => this.request({
            path: `/core/permits/import/attachments-standard-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Imports
         * @name PermitsImportAttachmentsCustomImportCreate
         * @request POST:/core/permits/import/attachments-custom-import
         * @secure
         */
        permitsImportAttachmentsCustomImportCreate: (data, params = {}) => this.request({
            path: `/core/permits/import/attachments-custom-import`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets a person by ID
         *
         * @tags Person
         * @name PersonsDetail
         * @request GET:/core/persons/{id}
         * @secure
         */
        personsDetail: (id, params = {}) => this.request({
            path: `/core/persons/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark a set of notifications as read and update everyone's badge count
         *
         * @tags Read Tracking
         * @name ReadTrackingExpireCreate
         * @request POST:/core/read-tracking/expire
         * @secure
         */
        readTrackingExpireCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/expire`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark a set of notifications as read
         *
         * @tags Read Tracking
         * @name ReadTrackingReadCreate
         * @request POST:/core/read-tracking/read
         * @secure
         */
        readTrackingReadCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/read`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all unread notifications [of a specific type]
         *
         * @tags Read Tracking
         * @name ReadTrackingUnreadList
         * @request GET:/core/read-tracking/unread
         * @secure
         */
        readTrackingUnreadList: (query, params = {}) => this.request({
            path: `/core/read-tracking/unread`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create new unread notification(s)
         *
         * @tags Read Tracking
         * @name ReadTrackingUnreadCreate
         * @request POST:/core/read-tracking/unread
         * @secure
         */
        readTrackingUnreadCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/unread`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a report
         *
         * @tags Legacy Reports
         * @name ReportsDelete
         * @request DELETE:/core/reports/{id}
         * @secure
         */
        reportsDelete: (id, params = {}) => this.request({
            path: `/core/reports/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Custom Fields
         * @name CustomFieldsPartialUpdate2
         * @request PATCH:/core/{objectType}/custom-fields/{id}
         * @originalName customFieldsPartialUpdate
         * @duplicate
         * @secure
         */
        customFieldsPartialUpdate2: (objectType, id, data, params = {}) => this.request({
            path: `/core/${objectType}/custom-fields/${id}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets the picklist items for a given 'pick-name'. This is a legacy thing.
         *
         * @tags Agency
         * @name AgencyPicklistDetail
         * @summary Get pick-list items
         * @request GET:/core/agency/picklist/{pickName}
         * @secure
         */
        agencyPicklistDetail: (pickName, params = {}) => this.request({
            path: `/core/agency/picklist/${pickName}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get array of JSON objects with agency app ids and links that can be opened in mobile apps
         *
         * @tags Agency
         * @name AgencySettingsAppleAppStoreAssociationList
         * @request GET:/core/agency/settings/apple-app-store-association
         */
        agencySettingsAppleAppStoreAssociationList: (params = {}) => this.request({
            path: `/core/agency/settings/apple-app-store-association`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Retrieves country data (states, postal code format, iso2, etc.) for an agency's country.
         *
         * @tags Agency
         * @name AgencySettingsCountryList
         * @summary Retrieve country for agency
         * @request GET:/core/agency/settings/country
         */
        agencySettingsCountryList: (params = {}) => this.request({
            path: `/core/agency/settings/country`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get CRM field attributes for an agency
         *
         * @tags Agency
         * @name AgencySettingsCrmFieldAttributesList
         * @request GET:/core/agency/settings/crm-field-attributes
         * @secure
         */
        agencySettingsCrmFieldAttributesList: (params = {}) => this.request({
            path: `/core/agency/settings/crm-field-attributes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get array of JSON objects with agency app ids and SHA-256 signing.
         *
         * @tags Agency
         * @name AgencySettingsDigitalAssetLinksList
         * @request GET:/core/agency/settings/digital-asset-links
         */
        agencySettingsDigitalAssetLinksList: (query, params = {}) => this.request({
            path: `/core/agency/settings/digital-asset-links`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Get an agency's general settings
         *
         * @tags Agency
         * @name AgencySettingsGeneralSettingsList
         * @request GET:/core/agency/settings/general-settings
         * @secure
         */
        agencySettingsGeneralSettingsList: (params = {}) => this.request({
            path: `/core/agency/settings/general-settings`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update agency's general settings.
         *
         * @tags Agency
         * @name AgencySettingsGeneralSettingsUpdate
         * @request PUT:/core/agency/settings/general-settings
         * @secure
         */
        agencySettingsGeneralSettingsUpdate: (data, params = {}) => this.request({
            path: `/core/agency/settings/general-settings`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the well known Microsoft Application IDs associated with core
         *
         * @tags Agency
         * @name AgencySettingsMicrosoftIdentityAssociationList
         * @request GET:/core/agency/settings/microsoft-identity-association
         */
        agencySettingsMicrosoftIdentityAssociationList: (params = {}) => this.request({
            path: `/core/agency/settings/microsoft-identity-association`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Send an OTP challenge to the identifier
         *
         * @tags Auth
         * @name AuthOtpSendCreate
         * @request POST:/core/auth/otp/send
         */
        authOtpSendCreate: (data, params = {}) => this.request({
            path: `/core/auth/otp/send`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Using an OTP code, update the email address of the user
         *
         * @tags Auth
         * @name AuthOtpUpdateEmailUpdate
         * @request PUT:/core/auth/otp/update-email
         * @secure
         */
        authOtpUpdateEmailUpdate: (data, params = {}) => this.request({
            path: `/core/auth/otp/update-email`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Using an OTP code, update the phone number of the user
         *
         * @tags Auth
         * @name AuthOtpUpdatePhoneUpdate
         * @request PUT:/core/auth/otp/update-phone
         * @secure
         */
        authOtpUpdatePhoneUpdate: (data, params = {}) => this.request({
            path: `/core/auth/otp/update-phone`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Accept a valid OTP and verifies the user
         *
         * @tags Auth
         * @name AuthOtpVerifyEmailCreate
         * @request POST:/core/auth/otp/verify-email
         */
        authOtpVerifyEmailCreate: (data, params = {}) => this.request({
            path: `/core/auth/otp/verify-email`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get agency's mapping between Location custom fields and CE custom fields.
         *
         * @tags CE
         * @name CeGeneralSettingsLocationMappingList
         * @request GET:/core/ce/general-settings/location-mapping
         * @secure
         */
        ceGeneralSettingsLocationMappingList: (params = {}) => this.request({
            path: `/core/ce/general-settings/location-mapping`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags CE Letters
         * @name CeLettersDetail
         * @request GET:/core/ce/letters/{id}
         * @secure
         */
        ceLettersDetail: (id, params = {}) => this.request({
            path: `/core/ce/letters/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all Facebook integrations for a city
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookList
         * @request GET:/core/communications/integrations/facebook
         * @secure
         */
        communicationsIntegrationsFacebookList: (params = {}) => this.request({
            path: `/core/communications/integrations/facebook`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new Facebook integration form the token obtained from /core/communications/integrations/facebook/token
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookCreate
         * @request POST:/core/communications/integrations/facebook
         * @secure
         */
        communicationsIntegrationsFacebookCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/facebook`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all Instagram integrations for a city
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramList
         * @request GET:/core/communications/integrations/instagram
         * @secure
         */
        communicationsIntegrationsInstagramList: (params = {}) => this.request({
            path: `/core/communications/integrations/instagram`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new Instagram integration from the token obtained from /core/communications/integrations/instagram/token
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramCreate
         * @request POST:/core/communications/integrations/instagram
         * @secure
         */
        communicationsIntegrationsInstagramCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/instagram`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all Twitter integrations for a city
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterList
         * @request GET:/core/communications/integrations/twitter
         * @secure
         */
        communicationsIntegrationsTwitterList: (params = {}) => this.request({
            path: `/core/communications/integrations/twitter`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new Twitter integration form the token obtained from /core/communications/integrations/twitter/token
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterCreate
         * @request POST:/core/communications/integrations/twitter
         * @secure
         */
        communicationsIntegrationsTwitterCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/twitter`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Follow a CRM case
         *
         * @tags CRM
         * @name CrmFollowersCreate
         * @request POST:/core/crm/{id}/followers
         * @secure
         */
        crmFollowersCreate: (id, params = {}) => this.request({
            path: `/core/crm/${id}/followers`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Unfollow a CRM case
         *
         * @tags CRM
         * @name CrmFollowersDelete
         * @request DELETE:/core/crm/{id}/followers
         * @secure
         */
        crmFollowersDelete: (id, params = {}) => this.request({
            path: `/core/crm/${id}/followers`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the related parents of crm comment(s)
         *
         * @tags CRM, CRM Comments
         * @name CrmCommentsParentsList
         * @request GET:/core/crm/comments/parents
         * @secure
         */
        crmCommentsParentsList: (query, params = {}) => this.request({
            path: `/core/crm/comments/parents`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a request by ID for the current user
         *
         * @tags CRM, CRM Requests
         * @name CrmPublicDetail
         * @request GET:/core/crm/public/{id}
         * @secure
         */
        crmPublicDetail: (id, params = {}) => this.request({
            path: `/core/crm/public/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Search CRM cases
         *
         * @tags CRM
         * @name CrmSearchDemoCreate
         * @request POST:/core/crm/search/demo
         * @secure
         */
        crmSearchDemoCreate: (data, params = {}) => this.request({
            path: `/core/crm/search/demo`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get nearby duplicate CRM cases
         *
         * @tags CRM
         * @name CrmSearchNearbyList
         * @request GET:/core/crm/search/nearby
         * @secure
         */
        crmSearchNearbyList: (query, params = {}) => this.request({
            path: `/core/crm/search/nearby`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a topic by ID
         *
         * @tags Crm Topics
         * @name CrmTopicsDetail
         * @request GET:/core/crm/topics/{id}
         */
        crmTopicsDetail: (id, params = {}) => this.request({
            path: `/core/crm/topics/${id}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Update topic
         *
         * @tags Crm Topics
         * @name CrmTopicsUpdate
         * @request PUT:/core/crm/topics/{id}
         */
        crmTopicsUpdate: (id, data, query, params = {}) => this.request({
            path: `/core/crm/topics/${id}`,
            method: "PUT",
            query: query,
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete topic
         *
         * @tags Crm Topics
         * @name CrmTopicsDelete
         * @request DELETE:/core/crm/topics/{id}
         */
        crmTopicsDelete: (id, query, params = {}) => this.request({
            path: `/core/crm/topics/${id}`,
            method: "DELETE",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the default assignee for a topic
         *
         * @tags Crm Topics
         * @name CrmTopicsAssigneeList
         * @request GET:/core/crm/topics/assignee
         * @secure
         */
        crmTopicsAssigneeList: (query, params = {}) => this.request({
            path: `/core/crm/topics/assignee`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a CSV with the agency's topics data
         *
         * @tags Crm Topics
         * @name CrmTopicsExportCreate
         * @request POST:/core/crm/topics/export
         */
        crmTopicsExportCreate: (params = {}) => this.request({
            path: `/core/crm/topics/export`,
            method: "POST",
            format: "json",
            ...params,
        }),
        /**
         * @description Get all public topics for the current site.
         *
         * @tags Crm Topics
         * @name CrmTopicsPublicList
         * @request GET:/core/crm/topics/public
         * @secure
         */
        crmTopicsPublicList: (params = {}) => this.request({
            path: `/core/crm/topics/public`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate a custom field, will throw 400 if field is a standard field
         *
         * @tags Custom Fields
         * @name CustomFieldsDeactivatedUpdate
         * @request PUT:/core/custom-fields/{id}/deactivated
         * @secure
         */
        customFieldsDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/custom-fields/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate a custom field
         *
         * @tags Custom Fields
         * @name CustomFieldsDeactivatedDelete
         * @request DELETE:/core/custom-fields/{id}/deactivated
         * @secure
         */
        customFieldsDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/custom-fields/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Check if a department can be deleted
         *
         * @tags CRM Departments
         * @name DepartmentsCheckDeleteDetail
         * @request GET:/core/departments/{id}/check-delete
         */
        departmentsCheckDeleteDetail: (id, params = {}) => this.request({
            path: `/core/departments/${id}/check-delete`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get permissions for a department
         *
         * @tags CRM Department Permissions
         * @name DepartmentsPermissionsDetail
         * @request GET:/core/departments/{id}/permissions
         */
        departmentsPermissionsDetail: (id, params = {}) => this.request({
            path: `/core/departments/${id}/permissions`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Update permissions for a department
         *
         * @tags CRM Department Permissions
         * @name DepartmentsPermissionsUpdate
         * @request PUT:/core/departments/{id}/permissions
         */
        departmentsPermissionsUpdate: (id, data, params = {}) => this.request({
            path: `/core/departments/${id}/permissions`,
            method: "PUT",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Download a document by id
         *
         * @tags Documents
         * @name DocumentsDownloadDetail
         * @request GET:/core/documents/{id}/download
         * @secure
         */
        documentsDownloadDetail: (id, params = {}) => this.request({
            path: `/core/documents/${id}/download`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Documents
         * @name DocumentsGenerateBulkCreate
         * @request POST:/core/documents/generate/bulk
         * @secure
         */
        documentsGenerateBulkCreate: (data, params = {}) => this.request({
            path: `/core/documents/generate/bulk`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Documents
         * @name DocumentsGeneratePreviewCreate
         * @request POST:/core/documents/generate/preview
         * @secure
         */
        documentsGeneratePreviewCreate: (data, params = {}) => this.request({
            path: `/core/documents/generate/preview`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Documents
         * @name DocumentsGenerateTestCreate
         * @request POST:/core/documents/generate/test
         * @secure
         */
        documentsGenerateTestCreate: (data, params = {}) => this.request({
            path: `/core/documents/generate/test`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a document template by id
         *
         * @tags Documents
         * @name DocumentsTemplatesDetail
         * @request GET:/core/documents/templates/{id}
         * @secure
         */
        documentsTemplatesDetail: (id, params = {}) => this.request({
            path: `/core/documents/templates/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a document template by id
         *
         * @tags Documents
         * @name DocumentsTemplatesUpdate
         * @request PUT:/core/documents/templates/{id}
         * @secure
         */
        documentsTemplatesUpdate: (id, data, params = {}) => this.request({
            path: `/core/documents/templates/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Updates file metadata after file upload
         *
         * @tags File Upload
         * @name FileFinalizedCreate
         * @request POST:/core/file/{id}/finalized
         * @secure
         */
        fileFinalizedCreate: (id, params = {}) => this.request({
            path: `/core/file/${id}/finalized`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get progress of video processing
         *
         * @tags Video Processing
         * @name FileVideoDetail
         * @request GET:/core/file/{id}/video
         * @secure
         */
        fileVideoDetail: (id, params = {}) => this.request({
            path: `/core/file/${id}/video`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an inspection's address by id
         *
         * @tags Inspections
         * @name InspectionsAddressPartialUpdate
         * @request PATCH:/core/inspections/{id}/address
         * @secure
         */
        inspectionsAddressPartialUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/address`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Fail an inspection by id
         *
         * @tags Inspections
         * @name InspectionsFailUpdate
         * @request PUT:/core/inspections/{id}/fail
         * @secure
         */
        inspectionsFailUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/fail`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an inspections on-site contact info by id
         *
         * @tags Inspections
         * @name InspectionsOnSiteContactInfoUpdate
         * @request PUT:/core/inspections/{id}/on-site-contact-info
         * @secure
         */
        inspectionsOnSiteContactInfoUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/on-site-contact-info`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Pass an inspection by id
         *
         * @tags Inspections
         * @name InspectionsPassUpdate
         * @request PUT:/core/inspections/{id}/pass
         * @secure
         */
        inspectionsPassUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/pass`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all previous inspections for a given re-inspection
         *
         * @tags Inspections
         * @name InspectionsPreviousInspectionsDetail
         * @request GET:/core/inspections/{id}/previous-inspections
         * @secure
         */
        inspectionsPreviousInspectionsDetail: (id, params = {}) => this.request({
            path: `/core/inspections/${id}/previous-inspections`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an inspections primary location
         *
         * @tags Inspections
         * @name InspectionsPrimaryLocationPartialUpdate
         * @request PATCH:/core/inspections/{id}/primary-location
         * @secure
         */
        inspectionsPrimaryLocationPartialUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/primary-location`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Schedule an inspection
         *
         * @tags Inspections
         * @name InspectionsScheduleUpdate
         * @request PUT:/core/inspections/{id}/schedule
         * @secure
         */
        inspectionsScheduleUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/schedule`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the schedule for an inspection
         *
         * @tags Inspections
         * @name InspectionsScheduleDetail
         * @request GET:/core/inspections/{id}/schedule
         * @secure
         */
        inspectionsScheduleDetail: (id, params = {}) => this.request({
            path: `/core/inspections/${id}/schedule`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete an inspections schedule-at date
         *
         * @tags Inspections
         * @name InspectionsScheduledAtDelete
         * @request DELETE:/core/inspections/{id}/scheduled-at
         * @secure
         */
        inspectionsScheduledAtDelete: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/scheduled-at`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Schedule an inspection
         *
         * @tags Inspections
         * @name InspectionsStartedAtCreate
         * @request POST:/core/inspections/{id}/started-at
         * @secure
         */
        inspectionsStartedAtCreate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/started-at`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets the public/citizen version of an inspection
         *
         * @tags Inspections
         * @name InspectionsPublicDetail
         * @request GET:/core/inspections/public/{id}
         * @secure
         */
        inspectionsPublicDetail: (id, params = {}) => this.request({
            path: `/core/inspections/public/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get an inspection-type by its id
         *
         * @tags Inspections
         * @name InspectionsTypesDetail
         * @request GET:/core/inspections/types/{id}
         * @secure
         */
        inspectionsTypesDetail: (id, query, params = {}) => this.request({
            path: `/core/inspections/types/${id}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an inspection-type by id
         *
         * @tags Inspections
         * @name InspectionsTypesUpdate
         * @request PUT:/core/inspections/types/{id}
         * @secure
         */
        inspectionsTypesUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/types/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncUpdate
         * @request PUT:/core/integrations/data-sync/{id}
         * @secure
         */
        integrationsDataSyncUpdate: (id, data, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Hard delete a data sync integration. WARNING, THIS IS NOT THE SAME AS DEACTIVATING.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncDelete
         * @request DELETE:/core/integrations/data-sync/{id}
         * @secure
         */
        integrationsDataSyncDelete: (id, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncDetail
         * @request GET:/core/integrations/data-sync/{id}
         * @secure
         */
        integrationsDataSyncDetail: (id, query, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get default configurations for a new data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncNewList
         * @request GET:/core/integrations/data-sync/new
         * @secure
         */
        integrationsDataSyncNewList: (query, params = {}) => this.request({
            path: `/core/integrations/data-sync/new`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Find code enforcement cases for this location.
         *
         * @tags Locations
         * @name LocationsCodeEnforcementCasesDetail
         * @request GET:/core/locations/{id}/code-enforcement-cases
         * @secure
         */
        locationsCodeEnforcementCasesDetail: (id, query, params = {}) => this.request({
            path: `/core/locations/${id}/code-enforcement-cases`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a location by id
         *
         * @tags Locations
         * @name LocationsDeactivatedUpdate
         * @request PUT:/core/locations/{id}/deactivated
         * @secure
         */
        locationsDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/locations/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a location by id
         *
         * @tags Locations
         * @name LocationsDeactivatedDelete
         * @request DELETE:/core/locations/{id}/deactivated
         * @secure
         */
        locationsDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/locations/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Find associations for this location
         *
         * @tags Locations
         * @name LocationsHistoryDetail
         * @request GET:/core/locations/{id}/history
         * @secure
         */
        locationsHistoryDetail: (id, params = {}) => this.request({
            path: `/core/locations/${id}/history`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Locations
         * @name LocationsCustomFieldsDefaultsCreate
         * @request POST:/core/locations/custom-fields/defaults
         * @secure
         */
        locationsCustomFieldsDefaultsCreate: (params = {}) => this.request({
            path: `/core/locations/custom-fields/defaults`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deletes an email off the suppression list (if the email is on the list)
         *
         * @tags Mail
         * @name MailSuppressionListDeleteCreate
         * @request POST:/core/mail/suppression-list/delete
         * @secure
         */
        mailSuppressionListDeleteCreate: (data, params = {}) => this.request({
            path: `/core/mail/suppression-list/delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets the an email off the suppression list (if the email is on the list)
         *
         * @tags Mail
         * @name MailSuppressionListQueryCreate
         * @request POST:/core/mail/suppression-list/query
         * @secure
         */
        mailSuppressionListQueryCreate: (data, params = {}) => this.request({
            path: `/core/mail/suppression-list/query`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get an AdHoc feature
         *
         * @tags Mapping
         * @name MappingFeaturesDetail
         * @request GET:/core/mapping/features/{id}
         * @secure
         */
        mappingFeaturesDetail: (id, params = {}) => this.request({
            path: `/core/mapping/features/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete an AdHoc feature
         *
         * @tags Mapping
         * @name MappingFeaturesDelete2
         * @request DELETE:/core/mapping/features/{id}
         * @originalName mappingFeaturesDelete
         * @duplicate
         * @secure
         */
        mappingFeaturesDelete2: (id, params = {}) => this.request({
            path: `/core/mapping/features/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an AdHoc feature
         *
         * @tags Mapping
         * @name MappingFeaturesUpdate2
         * @request PUT:/core/mapping/features/{id}
         * @originalName mappingFeaturesUpdate
         * @duplicate
         * @secure
         */
        mappingFeaturesUpdate2: (id, data, params = {}) => this.request({
            path: `/core/mapping/features/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Search map features
         *
         * @tags Maps
         * @name MappingFeaturesSearchCreate
         * @request POST:/core/mapping/features/search
         * @secure
         */
        mappingFeaturesSearchCreate: (data, params = {}) => this.request({
            path: `/core/mapping/features/search`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a map layer
         *
         * @tags Mapping
         * @name MappingLayersDetail
         * @request GET:/core/mapping/layers/{id}
         * @secure
         */
        mappingLayersDetail: (id, params = {}) => this.request({
            path: `/core/mapping/layers/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate a map layer
         *
         * @tags Mapping
         * @name MappingLayersDelete
         * @request DELETE:/core/mapping/layers/{id}
         * @secure
         */
        mappingLayersDelete: (id, params = {}) => this.request({
            path: `/core/mapping/layers/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate a map layer
         *
         * @tags Mapping
         * @name MappingLayersCreate2
         * @request POST:/core/mapping/layers/{id}
         * @originalName mappingLayersCreate
         * @duplicate
         * @secure
         */
        mappingLayersCreate2: (id, params = {}) => this.request({
            path: `/core/mapping/layers/${id}`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a map layer
         *
         * @tags Mapping
         * @name MappingLayersUpdate
         * @request PUT:/core/mapping/layers/{id}
         * @secure
         */
        mappingLayersUpdate: (id, data, params = {}) => this.request({
            path: `/core/mapping/layers/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Search map layers
         *
         * @tags Maps
         * @name MappingLayersSearchCreate
         * @request POST:/core/mapping/layers/search
         * @secure
         */
        mappingLayersSearchCreate: (data, params = {}) => this.request({
            path: `/core/mapping/layers/search`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get many static maps urls by coordinates
         *
         * @tags Mapping, Static Maps
         * @name MappingStaticMapUrlsCreate
         * @request POST:/core/mapping/static-map/urls
         * @secure
         */
        mappingStaticMapUrlsCreate: (data, params = {}) => this.request({
            path: `/core/mapping/static-map/urls`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get site grayout (agency boundary)
         *
         * @tags Mobile
         * @name MobileSiteInfoGrayoutList
         * @request GET:/core/mobile/site-info/grayout
         */
        mobileSiteInfoGrayoutList: (params = {}) => this.request({
            path: `/core/mobile/site-info/grayout`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Filter people by boundaries
         *
         * @tags Notify, Geotargeting
         * @name NotifyGeotargetingFilterByBoundaryCreate
         * @request POST:/core/notify/geotargeting/filter-by-boundary
         * @secure
         */
        notifyGeotargetingFilterByBoundaryCreate: (data, params = {}) => this.request({
            path: `/core/notify/geotargeting/filter-by-boundary`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Send SMS and Email invitations to a list of users
         *
         * @tags Notify
         * @name NotifyInviteBulkCreate
         * @request POST:/core/notify/invite/bulk
         * @secure
         */
        notifyInviteBulkCreate: (data, params = {}) => this.request({
            path: `/core/notify/invite/bulk`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Retrieve a Notification Content Record by its Id
         *
         * @tags Notify
         * @name NotifyNotificationContentDetail
         * @request GET:/core/notify/notification-content/{contentId}
         */
        notifyNotificationContentDetail: (contentId, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Notify
         * @name NotifySettingsPublicList
         * @request GET:/core/notify/settings/public
         */
        notifySettingsPublicList: (params = {}) => this.request({
            path: `/core/notify/settings/public`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Send a notification to an anonymous contact via SMS
         *
         * @tags Notify
         * @name NotifySmsNotificationCreate
         * @request POST:/core/notify/sms/notification
         * @secure
         */
        notifySmsNotificationCreate: (data, params = {}) => this.request({
            path: `/core/notify/sms/notification`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get mass notification send list for sms channel
         *
         * @tags Notify
         * @name NotifySmsSendListList
         * @request GET:/core/notify/sms/send-list
         * @secure
         */
        notifySmsSendListList: (params = {}) => this.request({
            path: `/core/notify/sms/send-list`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodDetail
         * @request GET:/core/notify/subscriber-contact-method/{id}
         * @secure
         */
        notifySubscriberContactMethodDetail: (id, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodDelete
         * @request DELETE:/core/notify/subscriber-contact-method/{id}
         * @secure
         */
        notifySubscriberContactMethodDelete: (id, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DANGER: Force opt-in a subscriber contact method and bypass the invite/opt-in process
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodOptInCreate
         * @request POST:/core/notify/subscriber-contact-method/opt-in
         * @secure
         */
        notifySubscriberContactMethodOptInCreate: (data, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/opt-in`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Opt out and delete subscription preferences for subscriber contact methods
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodOptOutCreate
         * @request POST:/core/notify/subscriber-contact-method/opt-out
         * @secure
         */
        notifySubscriberContactMethodOptOutCreate: (data, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/opt-out`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets all subscriber contact methods for logged in user. If not an anonymous user, and no subscriber contact methods exist for the user, a new one will be created for the user's email address and automatically enrolled.
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodPublicUpdate
         * @request PUT:/core/notify/subscriber-contact-method/public
         * @secure
         */
        notifySubscriberContactMethodPublicUpdate: (data, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/public`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all subscription groups
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodSearchList
         * @request GET:/core/notify/subscriber-contact-method/search
         * @secure
         */
        notifySubscriberContactMethodSearchList: (query, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/search`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Gets a list of all subscription groups available publicly
         *
         * @tags Notify
         * @name NotifySubscriptionGroupPublicList
         * @request GET:/core/notify/subscription-group/public
         */
        notifySubscriptionGroupPublicList: (params = {}) => this.request({
            path: `/core/notify/subscription-group/public`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get a subscription group
         *
         * @tags Notify
         * @name NotifySubscriptionGroupDetail
         * @request GET:/core/notify/subscription-group/{id}
         * @secure
         */
        notifySubscriptionGroupDetail: (id, params = {}) => this.request({
            path: `/core/notify/subscription-group/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a subscription group
         *
         * @tags Notify
         * @name NotifySubscriptionGroupUpdate
         * @request PUT:/core/notify/subscription-group/{id}
         * @secure
         */
        notifySubscriptionGroupUpdate: (id, data, params = {}) => this.request({
            path: `/core/notify/subscription-group/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Send a notification to an anonymous contact via Voice
         *
         * @tags Notify
         * @name NotifyVoiceNotificationCreate
         * @request POST:/core/notify/voice/notification
         * @secure
         */
        notifyVoiceNotificationCreate: (data, params = {}) => this.request({
            path: `/core/notify/voice/notification`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get mass notification send list for voice channel
         *
         * @tags Notify
         * @name NotifyVoiceSendListList
         * @request GET:/core/notify/voice/send-list
         * @secure
         */
        notifyVoiceSendListList: (query, params = {}) => this.request({
            path: `/core/notify/voice/send-list`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a transaction report for the city.
         *
         * @tags Reports
         * @name PermitsReportTransactionsCreate
         * @request POST:/core/permits/report/transactions/
         * @secure
         */
        permitsReportTransactionsCreate: (data, params = {}) => this.request({
            path: `/core/permits/report/transactions/`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a sales detail report for the city.
         *
         * @tags Reports
         * @name PermitsReportFeesCreate
         * @request POST:/core/permits/report/fees/
         * @secure
         */
        permitsReportFeesCreate: (data, params = {}) => this.request({
            path: `/core/permits/report/fees/`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark all notifications as read [of a specific type]
         *
         * @tags Read Tracking
         * @name ReadTrackingReadAllCreate
         * @request POST:/core/read-tracking/read/all
         * @secure
         */
        readTrackingReadAllCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/read/all`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark a global notification as read
         *
         * @tags Read Tracking
         * @name ReadTrackingReadGlobalCreate
         * @request POST:/core/read-tracking/read/global
         * @secure
         */
        readTrackingReadGlobalCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/read/global`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark a global notification as unread
         *
         * @tags Read Tracking
         * @name ReadTrackingUnreadGlobalCreate
         * @request POST:/core/read-tracking/unread/global
         * @secure
         */
        readTrackingUnreadGlobalCreate: (data, params = {}) => this.request({
            path: `/core/read-tracking/unread/global`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Webhook to trigger a data sync integration to pull data from an external source
         *
         * @tags Integrations
         * @name WebhooksDataSyncCreate
         * @request POST:/core/webhooks/data-sync/{hash}
         */
        webhooksDataSyncCreate: (hash, query, params = {}) => this.request({
            path: `/core/webhooks/data-sync/${hash}`,
            method: "POST",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a billing transaction in the specified account
         *
         * @tags Billing
         * @name BillingAccountsTransactionsCreate
         * @request POST:/core/billing/accounts/{accountId}/transactions
         * @secure
         */
        billingAccountsTransactionsCreate: (accountId, data, params = {}) => this.request({
            path: `/core/billing/accounts/${accountId}/transactions`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all billing transactions for the specified account
         *
         * @tags Billing
         * @name BillingAccountsTransactionsDetail
         * @request GET:/core/billing/accounts/{accountId}/transactions
         * @secure
         */
        billingAccountsTransactionsDetail: (accountId, query, params = {}) => this.request({
            path: `/core/billing/accounts/${accountId}/transactions`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get values for CE fields that can be mapped to location fields.
         *
         * @tags CE
         * @name CeGeneralSettingsLocationMappingStandardCeFieldsList
         * @request GET:/core/ce/general-settings/location-mapping/standard-ce-fields
         * @secure
         */
        ceGeneralSettingsLocationMappingStandardCeFieldsList: (params = {}) => this.request({
            path: `/core/ce/general-settings/location-mapping/standard-ce-fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Queue after-update job for CE case
         *
         * @tags CE
         * @name CeHookAfterUpdateUpdate
         * @request PUT:/core/ce/hook/after-update/{id}
         * @secure
         */
        ceHookAfterUpdateUpdate: (id, params = {}) => this.request({
            path: `/core/ce/hook/after-update/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Re-index a CE record by ID
         *
         * @tags CE
         * @name CeSearchIndexUpdate
         * @request PUT:/core/ce/search/index/{id}
         * @secure
         */
        ceSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/ce/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives incoming sns email events
         *
         * @tags Communications
         * @name CommunicationsEmailHooksInboundCreate
         * @request POST:/core/communications/email/hooks/inbound
         */
        communicationsEmailHooksInboundCreate: (data, params = {}) => this.request({
            path: `/core/communications/email/hooks/inbound`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives incoming sns email status events
         *
         * @tags Communications
         * @name CommunicationsEmailHooksStatusCreate
         * @request POST:/core/communications/email/hooks/status
         */
        communicationsEmailHooksStatusCreate: (data, params = {}) => this.request({
            path: `/core/communications/email/hooks/status`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the details of an Facebook integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookDetail
         * @request GET:/core/communications/integrations/facebook/{id}
         * @secure
         */
        communicationsIntegrationsFacebookDetail: (id, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the fields of an Facebook integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookUpdate
         * @request PUT:/core/communications/integrations/facebook/{id}
         * @secure
         */
        communicationsIntegrationsFacebookUpdate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark the Facebook integration as deleted
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookDelete
         * @request DELETE:/core/communications/integrations/facebook/{id}
         * @secure
         */
        communicationsIntegrationsFacebookDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all Facebook pages for a city
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookPageList
         * @request GET:/core/communications/integrations/facebook/page
         * @secure
         */
        communicationsIntegrationsFacebookPageList: (params = {}) => this.request({
            path: `/core/communications/integrations/facebook/page`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Facebook token from the Facebook OAuth2 code
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookTokenCreate
         * @request POST:/core/communications/integrations/facebook/token
         * @secure
         */
        communicationsIntegrationsFacebookTokenCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/token`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the details of an Instagram integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramDetail
         * @request GET:/core/communications/integrations/instagram/{id}
         * @secure
         */
        communicationsIntegrationsInstagramDetail: (id, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the fields of an Instagram integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramUpdate
         * @request PUT:/core/communications/integrations/instagram/{id}
         * @secure
         */
        communicationsIntegrationsInstagramUpdate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark the Instagram integration as deleted
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramDelete
         * @request DELETE:/core/communications/integrations/instagram/{id}
         * @secure
         */
        communicationsIntegrationsInstagramDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create an Instagram token from the Instagram OAuth2 code
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramTokenCreate
         * @request POST:/core/communications/integrations/instagram/token
         * @secure
         */
        communicationsIntegrationsInstagramTokenCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/token`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the details of a Twitter Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterDetail
         * @request GET:/core/communications/integrations/twitter/{id}
         * @secure
         */
        communicationsIntegrationsTwitterDetail: (id, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the fields of a Twitter Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterUpdate
         * @request PUT:/core/communications/integrations/twitter/{id}
         * @secure
         */
        communicationsIntegrationsTwitterUpdate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Mark the given Twitter integration as deleted
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterDelete
         * @request DELETE:/core/communications/integrations/twitter/{id}
         * @secure
         */
        communicationsIntegrationsTwitterDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Twitter token from the Twitter OAuth2 code and verifier
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterTokenCreate
         * @request POST:/core/communications/integrations/twitter/token
         * @secure
         */
        communicationsIntegrationsTwitterTokenCreate: (data, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/token`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a CRM email for a case
         *
         * @tags CRM
         * @name CrmEmailCreate
         * @request POST:/core/crm/{id}/email/{type}
         * @secure
         */
        crmEmailCreate: (id, type, data, params = {}) => this.request({
            path: `/core/crm/${id}/email/${type}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Queue after-update job for CRM case
         *
         * @tags CRM
         * @name CrmHookAfterUpdateUpdate
         * @request PUT:/core/crm/hook/after-update/{id}
         * @secure
         */
        crmHookAfterUpdateUpdate: (id, params = {}) => this.request({
            path: `/core/crm/hook/after-update/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a request's attachments
         *
         * @tags CRM, CRM Attachments
         * @name CrmPublicAttachmentsDetail
         * @request GET:/core/crm/public/{id}/attachments
         * @secure
         */
        crmPublicAttachmentsDetail: (id, params = {}) => this.request({
            path: `/core/crm/public/${id}/attachments`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a request's comments
         *
         * @tags CRM, CRM Comments
         * @name CrmPublicCommentsDetail
         * @request GET:/core/crm/public/{id}/comments
         * @secure
         */
        crmPublicCommentsDetail: (id, params = {}) => this.request({
            path: `/core/crm/public/${id}/comments`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Add a comment to a request
         *
         * @tags CRM, CRM Comments
         * @name CrmPublicCommentsCreate
         * @request POST:/core/crm/public/{id}/comments
         * @secure
         */
        crmPublicCommentsCreate: (id, data, params = {}) => this.request({
            path: `/core/crm/public/${id}/comments`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Export CRM search results
         *
         * @tags CRM
         * @name CrmSearchDemoExportCreate
         * @request POST:/core/crm/search/demo/export
         * @secure
         */
        crmSearchDemoExportCreate: (data, params = {}) => this.request({
            path: `/core/crm/search/demo/export`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Get CRM field definitions for search
         *
         * @tags CRM
         * @name CrmSearchDemoFieldsList
         * @request GET:/core/crm/search/demo/fields
         * @secure
         */
        crmSearchDemoFieldsList: (params = {}) => this.request({
            path: `/core/crm/search/demo/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Get Lookup Fields for CRM search
         *
         * @tags CRM
         * @name CrmSearchDemoLookupList
         * @request GET:/core/crm/search/demo/lookup
         * @secure
         */
        crmSearchDemoLookupList: (query, params = {}) => this.request({
            path: `/core/crm/search/demo/lookup`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Get Views for CRM search
         *
         * @tags CRM
         * @name CrmSearchDemoViewsList
         * @request GET:/core/crm/search/demo/views
         * @secure
         */
        crmSearchDemoViewsList: (params = {}) => this.request({
            path: `/core/crm/search/demo/views`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Create new view for CRM search
         *
         * @tags CRM
         * @name CrmSearchDemoViewsCreate
         * @request POST:/core/crm/search/demo/views
         * @secure
         */
        crmSearchDemoViewsCreate: (data, params = {}) => this.request({
            path: `/core/crm/search/demo/views`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Re-index a CRM record by ID
         *
         * @tags CRM
         * @name CrmSearchIndexUpdate
         * @request PUT:/core/crm/search/index/{id}
         * @secure
         */
        crmSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/crm/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate topic
         *
         * @tags Crm Topics
         * @name CrmTopicsDeactivateUpdate
         * @request PUT:/core/crm/topics/{id}/deactivate
         */
        crmTopicsDeactivateUpdate: (id, params = {}) => this.request({
            path: `/core/crm/topics/${id}/deactivate`,
            method: "PUT",
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate topic
         *
         * @tags Crm Topics
         * @name CrmTopicsReactivateUpdate
         * @request PUT:/core/crm/topics/{id}/reactivate
         */
        crmTopicsReactivateUpdate: (id, params = {}) => this.request({
            path: `/core/crm/topics/${id}/reactivate`,
            method: "PUT",
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate a document template by id
         *
         * @tags Documents
         * @name DocumentsTemplatesDeactivatedDelete
         * @request DELETE:/core/documents/templates/{id}/deactivated
         * @secure
         */
        documentsTemplatesDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/documents/templates/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate a document template by id
         *
         * @tags Documents
         * @name DocumentsTemplatesDeactivatedUpdate
         * @request PUT:/core/documents/templates/{id}/deactivated
         * @secure
         */
        documentsTemplatesDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/documents/templates/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Download a document template by id
         *
         * @tags Documents
         * @name DocumentsTemplatesDownloadDetail
         * @request GET:/core/documents/templates/{id}/download
         * @secure
         */
        documentsTemplatesDownloadDetail: (id, params = {}) => this.request({
            path: `/core/documents/templates/${id}/download`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Retrieve a thumbnail for a file
         *
         * @tags Thumbnails
         * @name FileThumbnailDetail
         * @request GET:/core/file/{id}/thumbnail/{size}
         * @secure
         */
        fileThumbnailDetail: (id, size, params = {}) => this.request({
            path: `/core/file/${id}/thumbnail/${size}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Updates file metadata and finishes a multipart file upload
         *
         * @tags File Upload
         * @name FileMultipartFinalizedCreate
         * @request POST:/core/file/multipart/{id}/finalized
         * @secure
         */
        fileMultipartFinalizedCreate: (id, data, params = {}) => this.request({
            path: `/core/file/multipart/${id}/finalized`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Rejects the request associated with an inspection
         *
         * @tags Inspections
         * @name InspectionsRequestRejectUpdate
         * @request PUT:/core/inspections/{id}/request/reject
         * @secure
         */
        inspectionsRequestRejectUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/${id}/request/reject`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the scheduler time slot options for inspections
         *
         * @tags Inspections
         * @name InspectionsTimeSlotOptionsDetail
         * @request GET:/core/inspections/{id}/time-slot/options
         * @secure
         */
        inspectionsTimeSlotOptionsDetail: (id, params = {}) => this.request({
            path: `/core/inspections/${id}/time-slot/options`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an inspections on-site contact info by id
         *
         * @tags Inspections
         * @name InspectionsPublicOnSiteContactInfoUpdate
         * @request PUT:/core/inspections/public/{id}/on-site-contact-info
         * @secure
         */
        inspectionsPublicOnSiteContactInfoUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/public/${id}/on-site-contact-info`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List all previous inspections for a given re-inspection
         *
         * @tags Inspections
         * @name InspectionsPublicPreviousInspectionsDetail
         * @request GET:/core/inspections/public/{id}/previous-inspections
         * @secure
         */
        inspectionsPublicPreviousInspectionsDetail: (id, params = {}) => this.request({
            path: `/core/inspections/public/${id}/previous-inspections`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the citizen request associated with an inspection.
         *
         * @tags Inspections
         * @name InspectionsPublicRequestUpdate
         * @request PUT:/core/inspections/public/{id}/request
         * @secure
         */
        inspectionsPublicRequestUpdate: (id, data, params = {}) => this.request({
            path: `/core/inspections/public/${id}/request`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Re-index an Inspection record by ID
         *
         * @tags Inspections
         * @name InspectionsSearchIndexUpdate
         * @request PUT:/core/inspections/search/index/{id}
         * @secure
         */
        inspectionsSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/inspections/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate an inspection-type
         *
         * @tags Inspections
         * @name InspectionsTypesDeactivatedUpdate
         * @request PUT:/core/inspections/types/{id}/deactivated
         * @secure
         */
        inspectionsTypesDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/inspections/types/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate an inspection type
         *
         * @tags Inspections
         * @name InspectionsTypesDeactivatedDelete
         * @request DELETE:/core/inspections/types/{id}/deactivated
         * @secure
         */
        inspectionsTypesDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/inspections/types/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the schedule associated with an inspection-type
         *
         * @tags Inspections
         * @name InspectionsTypesScheduleDetail
         * @request GET:/core/inspections/types/{id}/schedule
         * @secure
         */
        inspectionsTypesScheduleDetail: (id, query, params = {}) => this.request({
            path: `/core/inspections/types/${id}/schedule`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get block-out day options for an inspection-type
         *
         * @tags Inspections
         * @name InspectionsTypesBlockOutDaysOptionsList
         * @request GET:/core/inspections/types/block-out-days/options
         * @secure
         */
        inspectionsTypesBlockOutDaysOptionsList: (params = {}) => this.request({
            path: `/core/inspections/types/block-out-days/options`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Checks if a record has been synced to an external system and returns the data sync record if it exists
         *
         * @tags Integrations
         * @name IntegrationsDataSyncDetail2
         * @request GET:/core/integrations/data-sync/{id}/{recordId}
         * @originalName integrationsDataSyncDetail
         * @duplicate
         * @secure
         */
        integrationsDataSyncDetail2: (id, recordId, query, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/${recordId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Either manually de-syncs a record from an integration, or hard deletes a record that has already been de-synced
         *
         * @tags Integrations
         * @name IntegrationsDataSyncDelete2
         * @request DELETE:/core/integrations/data-sync/{id}/{recordId}
         * @originalName integrationsDataSyncDelete
         * @duplicate
         * @secure
         */
        integrationsDataSyncDelete2: (id, recordId, query, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/${recordId}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Manually push a record to an external system, creates the data sync record if it doesn't exist, and enqueues a job to push the record to the external system
         *
         * @tags Integrations
         * @name IntegrationsDataSyncCreate2
         * @request POST:/core/integrations/data-sync/{id}/{recordId}
         * @originalName integrationsDataSyncCreate
         * @duplicate
         * @secure
         */
        integrationsDataSyncCreate2: (id, recordId, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/${recordId}`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Enables a data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncEnableUpdate
         * @request PUT:/core/integrations/data-sync/{id}/enable
         * @secure
         */
        integrationsDataSyncEnableUpdate: (id, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/enable`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Checks a record passed as json against the filters of an integration and returns which filters it matched
         *
         * @tags Integrations
         * @name IntegrationsDataSyncFiltersCreate
         * @request POST:/core/integrations/data-sync/{id}/filters
         * @secure
         */
        integrationsDataSyncFiltersCreate: (id, data, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/filters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Make requests to external system with core service as a proxy.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncProxyCreate
         * @request POST:/core/integrations/data-sync/{id}/proxy
         * @secure
         */
        integrationsDataSyncProxyCreate: (id, data, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/proxy`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Test the connection of a data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncTestCreate
         * @request POST:/core/integrations/data-sync/{id}/test
         * @secure
         */
        integrationsDataSyncTestCreate: (id, data, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/test`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Disables a data sync integration.
         *
         * @tags Integrations
         * @name IntegrationsDataSyncDisableUpdate
         * @request PUT:/core/integrations/data-sync/{id}/disable
         * @secure
         */
        integrationsDataSyncDisableUpdate: (id, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/disable`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get function that recives a shortened URL and redirects to the original URL
         *
         * @tags Link Shortener
         * @name LinkShortenerDetail2
         * @request GET:/core/link-shortener/{cityId}/{openCode}/{shortCode}
         * @originalName linkShortenerDetail
         * @duplicate
         */
        linkShortenerDetail2: (cityId, openCode, shortCode, params = {}) => this.request({
            path: `/core/link-shortener/${cityId}/${openCode}/${shortCode}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get all features for this layer
         *
         * @tags Mapping
         * @name MappingLayersFeaturesDetail
         * @request GET:/core/mapping/layers/{id}/features
         * @secure
         */
        mappingLayersFeaturesDetail: (id, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new feature for this layer
         *
         * @tags Mapping
         * @name MappingLayersFeaturesCreate
         * @request POST:/core/mapping/layers/{id}/features
         * @secure
         */
        mappingLayersFeaturesCreate: (id, data, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk edit features for this layer
         *
         * @tags Mapping
         * @name MappingLayersFeaturesUpdate
         * @request PUT:/core/mapping/layers/{id}/features
         * @secure
         */
        mappingLayersFeaturesUpdate: (id, data, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives incoming SMS message events coming from Twilio
         *
         * @tags Notify
         * @name NotifyHookSmsIncomingCreate
         * @request POST:/core/notify/hook/sms/incoming
         */
        notifyHookSmsIncomingCreate: (data, params = {}) => this.request({
            path: `/core/notify/hook/sms/incoming`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives sms status events coming from Twilio
         *
         * @tags Notify
         * @name NotifyHookSmsStatusCreate
         * @request POST:/core/notify/hook/sms/status
         */
        notifyHookSmsStatusCreate: (data, params = {}) => this.request({
            path: `/core/notify/hook/sms/status`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives voice status events coming from Twilio
         *
         * @tags Notify
         * @name NotifyHookVoiceStatusCreate
         * @request POST:/core/notify/hook/voice/status
         */
        notifyHookVoiceStatusCreate: (data, params = {}) => this.request({
            path: `/core/notify/hook/voice/status`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives incoming voice call events coming from Twilio
         *
         * @tags Notify
         * @name NotifyHookVoiceIncomingCreate
         * @request POST:/core/notify/hook/voice/incoming
         */
        notifyHookVoiceIncomingCreate: (data, params = {}) => this.request({
            path: `/core/notify/hook/voice/incoming`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get geotarget boundaries for a mass notification
         *
         * @tags Notify, Geotargeting
         * @name NotifyNotificationContentGeotargetingDetail
         * @request GET:/core/notify/notification-content/{contentId}/geotargeting
         * @secure
         */
        notifyNotificationContentGeotargetingDetail: (contentId, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/geotargeting`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Adds geotarget boundaries to a mass notification
         *
         * @tags Notify, Geotargeting
         * @name NotifyNotificationContentGeotargetingCreate
         * @request POST:/core/notify/notification-content/{contentId}/geotargeting
         * @secure
         */
        notifyNotificationContentGeotargetingCreate: (contentId, data, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/geotargeting`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Updates geotarget boundaries for a mass notification
         *
         * @tags Notify, Geotargeting
         * @name NotifyNotificationContentGeotargetingUpdate
         * @request PUT:/core/notify/notification-content/{contentId}/geotargeting
         * @secure
         */
        notifyNotificationContentGeotargetingUpdate: (contentId, data, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/geotargeting`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Removes geotarget boundaries for a mass notification
         *
         * @tags Notify, Geotargeting
         * @name NotifyNotificationContentGeotargetingDelete
         * @request DELETE:/core/notify/notification-content/{contentId}/geotargeting
         * @secure
         */
        notifyNotificationContentGeotargetingDelete: (contentId, data, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/geotargeting`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Send mass notification for notification content.  Omitting scheduledAt will send the notification immediately
         *
         * @tags Notify
         * @name NotifyNotificationContentMassNotificationCreate
         * @request POST:/core/notify/notification-content/{contentId}/mass-notification
         * @secure
         */
        notifyNotificationContentMassNotificationCreate: (contentId, data, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/mass-notification`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Reschedule mass notification for notification content. Omitting scheduledAt will send the notification immediately
         *
         * @tags Notify
         * @name NotifyNotificationContentMassNotificationUpdate
         * @request PUT:/core/notify/notification-content/{contentId}/mass-notification
         * @secure
         */
        notifyNotificationContentMassNotificationUpdate: (contentId, data, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/mass-notification`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Cancel scheduled mass notification for notification content
         *
         * @tags Notify
         * @name NotifyNotificationContentMassNotificationDelete
         * @request DELETE:/core/notify/notification-content/{contentId}/mass-notification
         * @secure
         */
        notifyNotificationContentMassNotificationDelete: (contentId, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/mass-notification`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Search for Notify Content Records
         *
         * @tags Notify
         * @name NotifyNotificationContentSearchPublicList
         * @request GET:/core/notify/notification-content/search/public
         * @secure
         */
        notifyNotificationContentSearchPublicList: (query, params = {}) => this.request({
            path: `/core/notify/notification-content/search/public`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get sms notification info (send list count, estimated cost, etc.)
         *
         * @tags Notify
         * @name NotifySmsNotificationInfoList
         * @request GET:/core/notify/sms/notification/info
         * @secure
         */
        notifySmsNotificationInfoList: (params = {}) => this.request({
            path: `/core/notify/sms/notification/info`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update Notify subscription preference
         *
         * @tags Notify
         * @name NotifySubscriberContactMethodSubscriptionPreferenceUpdate
         * @request PUT:/core/notify/subscriber-contact-method/{id}/subscription-preference
         * @secure
         */
        notifySubscriberContactMethodSubscriptionPreferenceUpdate: (id, data, params = {}) => this.request({
            path: `/core/notify/subscriber-contact-method/${id}/subscription-preference`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate a subscription group
         *
         * @tags Notify
         * @name NotifySubscriptionGroupDeactivatedUpdate
         * @request PUT:/core/notify/subscription-group/{id}/deactivated
         * @secure
         */
        notifySubscriptionGroupDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/notify/subscription-group/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate a subscription group
         *
         * @tags Notify
         * @name NotifySubscriptionGroupDeactivatedDelete
         * @request DELETE:/core/notify/subscription-group/{id}/deactivated
         * @secure
         */
        notifySubscriptionGroupDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/notify/subscription-group/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a voice audio resource file for a mass notification
         *
         * @tags Notify
         * @name NotifyVoiceNotificationGenerateCreate
         * @request POST:/core/notify/voice/notification/generate
         * @secure
         */
        notifyVoiceNotificationGenerateCreate: (data, params = {}) => this.request({
            path: `/core/notify/voice/notification/generate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get voice notification info (send list count, estimated cost, etc.)
         *
         * @tags Notify
         * @name NotifyVoiceNotificationInfoList
         * @request GET:/core/notify/voice/notification/info
         * @secure
         */
        notifyVoiceNotificationInfoList: (query, params = {}) => this.request({
            path: `/core/notify/voice/notification/info`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all notify incoming call IVR audio resources
         *
         * @tags Notify
         * @name NotifyVoiceAudioResourcePreGeneratedList
         * @request GET:/core/notify/voice/audio-resource/pre-generated
         * @secure
         */
        notifyVoiceAudioResourcePreGeneratedList: (params = {}) => this.request({
            path: `/core/notify/voice/audio-resource/pre-generated`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Re-index a Payout record by ID
         *
         * @tags Payouts
         * @name PayoutsSearchIndexUpdate
         * @request PUT:/core/payouts/search/index/{id}
         * @secure
         */
        payoutsSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/payouts/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Permits
         * @name PermitsSearchIndexUpdate
         * @request PUT:/core/permits/search/index/{id}
         * @secure
         */
        permitsSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/permits/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a Person's activity by ID
         *
         * @tags Person
         * @name PersonsActivityUpdate
         * @request PUT:/core/persons/{id}/activity/{type}
         * @secure
         */
        personsActivityUpdate: (id, type, params = {}) => this.request({
            path: `/core/persons/${id}/activity/${type}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Queue after-update job for Person record
         *
         * @tags Person
         * @name PersonsHookAfterUpdateUpdate
         * @request PUT:/core/persons/hook/after-update/{id}
         * @secure
         */
        personsHookAfterUpdateUpdate: (id, params = {}) => this.request({
            path: `/core/persons/hook/after-update/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Re-index a Person record by ID
         *
         * @tags Person
         * @name PersonsSearchIndexUpdate
         * @request PUT:/core/persons/search/index/{id}
         * @secure
         */
        personsSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/persons/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Transactions
         * @name TransactionsSearchIndexBulkUpdate
         * @request PUT:/core/transactions/search/index/bulk
         * @secure
         */
        transactionsSearchIndexBulkUpdate: (data, params = {}) => this.request({
            path: `/core/transactions/search/index/bulk`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Transactions
         * @name TransactionsSearchIndexUpdate
         * @request PUT:/core/transactions/search/index/{id}
         * @secure
         */
        transactionsSearchIndexUpdate: (id, params = {}) => this.request({
            path: `/core/transactions/search/index/${id}`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate a webhook hash for the integration
         *
         * @tags Integrations
         * @name WebhooksDataSyncGenerateUpdate
         * @request PUT:/core/webhooks/data-sync/{id}/generate
         * @secure
         */
        webhooksDataSyncGenerateUpdate: (id, params = {}) => this.request({
            path: `/core/webhooks/data-sync/${id}/generate`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Accept a valid OTP and return an anonymous token
         *
         * @tags Auth
         * @name AuthAnonymousTokenIssueViaOtpNotifyCreate
         * @request POST:/core/auth/anonymous-token/issue-via/otp/notify
         */
        authAnonymousTokenIssueViaOtpNotifyCreate: (data, params = {}) => this.request({
            path: `/core/auth/anonymous-token/issue-via/otp/notify`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate the Facebook Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookDeactivatedDelete
         * @request DELETE:/core/communications/integrations/facebook/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsFacebookDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate the Facebook Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookDeactivatedUpdate
         * @request PUT:/core/communications/integrations/facebook/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsFacebookDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Does a ping/health check on a Facebook Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookPingCreate
         * @request POST:/core/communications/integrations/facebook/{id}/ping
         * @secure
         */
        communicationsIntegrationsFacebookPingCreate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}/ping`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Reconnects a broken Facebook Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsFacebookReconnectUpdate
         * @request PUT:/core/communications/integrations/facebook/{id}/reconnect
         * @secure
         */
        communicationsIntegrationsFacebookReconnectUpdate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/facebook/${id}/reconnect`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Does a ping/health check on a Instagram Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramPingCreate
         * @request POST:/core/communications/integrations/instagram/{id}/ping
         * @secure
         */
        communicationsIntegrationsInstagramPingCreate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}/ping`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an existing Instagram integration from the token obtained from /core/communications/integrations/instagram/token
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramReconnectCreate
         * @request POST:/core/communications/integrations/instagram/{id}/reconnect
         * @secure
         */
        communicationsIntegrationsInstagramReconnectCreate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}/reconnect`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate the Instagram Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramDeactivatedDelete
         * @request DELETE:/core/communications/integrations/instagram/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsInstagramDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate the Instagram Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsInstagramDeactivatedUpdate
         * @request PUT:/core/communications/integrations/instagram/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsInstagramDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/communications/integrations/instagram/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Reactivate the Twitter Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterDeactivatedDelete
         * @request DELETE:/core/communications/integrations/twitter/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsTwitterDeactivatedDelete: (id, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}/deactivated`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Deactivate the Twitter Integration with the given id
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterDeactivatedUpdate
         * @request PUT:/core/communications/integrations/twitter/{id}/deactivated
         * @secure
         */
        communicationsIntegrationsTwitterDeactivatedUpdate: (id, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}/deactivated`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Does a ping/health check on a Twitter Integration
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterPingCreate
         * @request POST:/core/communications/integrations/twitter/{id}/ping
         * @secure
         */
        communicationsIntegrationsTwitterPingCreate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}/ping`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update an existing Twitter integration from the token obtained from /core/communications/integrations/twitter/token
         *
         * @tags Integrations
         * @name CommunicationsIntegrationsTwitterReconnectCreate
         * @request POST:/core/communications/integrations/twitter/{id}/reconnect
         * @secure
         */
        communicationsIntegrationsTwitterReconnectCreate: (id, data, params = {}) => this.request({
            path: `/core/communications/integrations/twitter/${id}/reconnect`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the attachment preview for a Crm attachment
         *
         * @tags CRM
         * @name CrmAttachmentPreviewDetail
         * @request GET:/core/crm/{id}/attachment/{attachmentId}/preview
         * @secure
         */
        crmAttachmentPreviewDetail: (id, attachmentId, query, params = {}) => this.request({
            path: `/core/crm/${id}/attachment/${attachmentId}/preview`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Update view for CRM search
         *
         * @tags CRM
         * @name CrmSearchDemoViewsUpdate
         * @request PUT:/core/crm/search/demo/views/{id}
         * @secure
         */
        crmSearchDemoViewsUpdate: (id, data, params = {}) => this.request({
            path: `/core/crm/search/demo/views/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description DEMO Get Views for CRM search
         *
         * @tags CRM
         * @name CrmSearchDemoViewsDelete
         * @request DELETE:/core/crm/search/demo/views/{id}
         * @secure
         */
        crmSearchDemoViewsDelete: (id, params = {}) => this.request({
            path: `/core/crm/search/demo/views/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get the # of cases associated with this classification, filtered by department
         *
         * @tags Crm Topics
         * @name CrmTopicsCasesCountDetail
         * @request GET:/core/crm/topics/cases/count/{id}
         */
        crmTopicsCasesCountDetail: (id, query, params = {}) => this.request({
            path: `/core/crm/topics/cases/count/${id}`,
            method: "GET",
            query: query,
            format: "json",
            ...params,
        }),
        /**
         * @description Checks a record against the filters of an integration and returns which filters it matched
         *
         * @tags Integrations
         * @name IntegrationsDataSyncFiltersDetail
         * @request GET:/core/integrations/data-sync/{id}/{recordId}/filters
         * @secure
         */
        integrationsDataSyncFiltersDetail: (id, recordId, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/${recordId}/filters`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Pull data from an external source for a data sync record
         *
         * @tags Integrations
         * @name IntegrationsDataSyncPullDetail
         * @request GET:/core/integrations/data-sync/{id}/{recordId}/pull
         */
        integrationsDataSyncPullDetail: (id, recordId, params = {}) => this.request({
            path: `/core/integrations/data-sync/${id}/${recordId}/pull`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Get a map feature
         *
         * @tags Mapping
         * @name MappingLayersFeaturesDetail2
         * @request GET:/core/mapping/layers/{id}/features/{featureId}
         * @originalName mappingLayersFeaturesDetail
         * @duplicate
         * @secure
         */
        mappingLayersFeaturesDetail2: (id, featureId, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features/${featureId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a map feature
         *
         * @tags Mapping
         * @name MappingLayersFeaturesDelete
         * @request DELETE:/core/mapping/layers/{id}/features/{featureId}
         * @secure
         */
        mappingLayersFeaturesDelete: (id, featureId, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features/${featureId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update fields for a map feature
         *
         * @tags Mapping
         * @name MappingLayersFeaturesUpdate2
         * @request PUT:/core/mapping/layers/{id}/features/{featureId}
         * @originalName mappingLayersFeaturesUpdate
         * @duplicate
         * @secure
         */
        mappingLayersFeaturesUpdate2: (id, featureId, data, params = {}) => this.request({
            path: `/core/mapping/layers/${id}/features/${featureId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create the default generated image for the notification
         *
         * @tags Notify
         * @name NotifyLegacyCmsImageDetail
         * @request GET:/core/notify/legacy/cms/{id}/image
         * @secure
         */
        notifyLegacyCmsImageDetail: (id, params = {}) => this.request({
            path: `/core/notify/legacy/cms/${id}/image`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create the Twitter content for a mass notification
         *
         * @tags Notify
         * @name NotifyLegacyMassNotificationTwitterCreate
         * @request POST:/core/notify/legacy/mass-notification/{id}/twitter
         * @secure
         */
        notifyLegacyMassNotificationTwitterCreate: (id, params = {}) => this.request({
            path: `/core/notify/legacy/mass-notification/${id}/twitter`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get results of mass notifications made for notification content
         *
         * @tags Notify
         * @name NotifyNotificationContentMassNotificationResultsDetail
         * @request GET:/core/notify/notification-content/{contentId}/mass-notification/results
         * @secure
         */
        notifyNotificationContentMassNotificationResultsDetail: (contentId, params = {}) => this.request({
            path: `/core/notify/notification-content/${contentId}/mass-notification/results`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Notify
         * @name NotifyPublicShareDetail
         * @request GET:/core/notify/public/share/{site}/{contentId}
         */
        notifyPublicShareDetail: (site, contentId, params = {}) => this.request({
            path: `/core/notify/public/share/${site}/${contentId}`,
            method: "GET",
            format: "json",
            ...params,
        }),
        /**
         * @description Generate all notify incoming call IVR audio resources
         *
         * @tags Notify
         * @name NotifyVoiceAudioResourcePreGeneratedGenerateUpdate
         * @request PUT:/core/notify/voice/audio-resource/pre-generated/generate
         * @secure
         */
        notifyVoiceAudioResourcePreGeneratedGenerateUpdate: (params = {}) => this.request({
            path: `/core/notify/voice/audio-resource/pre-generated/generate`,
            method: "PUT",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Creates an email for the CRM caselog/comment record linked to this CRM case
         *
         * @tags CRM
         * @name CrmCommentsEmailCreate
         * @request POST:/core/crm/{id}/comments/{commentId}/email/{type}
         * @secure
         */
        crmCommentsEmailCreate: (type, id, commentId, data, params = {}) => this.request({
            path: `/core/crm/${id}/comments/${commentId}/email/${type}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Receives incoming voice calls from Twilio. IVR menu for managing subscription. 1 to opt-in, 9 to opt-out
         *
         * @tags Notify
         * @name NotifyHookVoiceIncomingIvrManageSubscriptionCreate
         * @request POST:/core/notify/hook/voice/incoming/ivr/manage-subscription
         */
        notifyHookVoiceIncomingIvrManageSubscriptionCreate: (data, params = {}) => this.request({
            path: `/core/notify/hook/voice/incoming/ivr/manage-subscription`,
            method: "POST",
            body: data,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Add a comment to an inspection-item
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsCommentCreate
         * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment
         * @secure
         */
        inspectionsSectionsItemsCommentCreate: (id, sectionId, itemId, data, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all comments on an inspection item
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsCommentDetail
         * @request GET:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment
         * @secure
         */
        inspectionsSectionsItemsCommentDetail: (id, sectionId, itemId, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Fail an inspection-item by id
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsFailCreate
         * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/fail
         * @secure
         */
        inspectionsSectionsItemsFailCreate: (id, sectionId, itemId, data, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/fail`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Pass an inspection-item by id
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsPassCreate
         * @request POST:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/pass
         * @secure
         */
        inspectionsSectionsItemsPassCreate: (id, sectionId, itemId, data, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/pass`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get all previous comments for an inspection item
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsPreviousCommentsDetail
         * @request GET:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/previous-comments
         * @secure
         */
        inspectionsSectionsItemsPreviousCommentsDetail: (id, sectionId, itemId, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/previous-comments`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Clear an inspection-items status by id
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsStatusDelete
         * @request DELETE:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/status
         * @secure
         */
        inspectionsSectionsItemsStatusDelete: (id, sectionId, itemId, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/status`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a comment on an inspection-item
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsCommentUpdate
         * @request PUT:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment/{commentId}
         * @secure
         */
        inspectionsSectionsItemsCommentUpdate: (id, sectionId, itemId, commentId, data, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment/${commentId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a comment on an inspection-item
         *
         * @tags Inspections
         * @name InspectionsSectionsItemsCommentDelete
         * @request DELETE:/core/inspections/{id}/sections/{sectionId}/items/{itemId}/comment/{commentId}
         * @secure
         */
        inspectionsSectionsItemsCommentDelete: (id, sectionId, itemId, commentId, params = {}) => this.request({
            path: `/core/inspections/${id}/sections/${sectionId}/items/${itemId}/comment/${commentId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
